import { API } from "../api";

export type ClienteAnnouncement = {
  id: number;
  title: string;
  body: string;
  category: string;
  publishedAt: string | null;
};

export const getBannerAnnouncements = async () => {
  const { data } = await API.get<{ ok: true; data: ClienteAnnouncement[] }>("/api/comunicados/banner");
  return data.data;
};
